import { useEffect, useRef } from "react";

interface IFFormClassic {
  children: any;
  id:string;
  classes: string;
  onSubmit(e: any): void;
};
const defaultProps = {
  classes: "",
  id:"",
  onSubmit: null,
};

export const FormClassic = (props: IFFormClassic) => {

  const formElement = useRef(null);
  const handleSubmit = (form: any) => {
    form.addEventListener("submit", (e: any) => {
      e.preventDefault();
    });
  };

  useEffect(() => {
    formElement.current && handleSubmit(formElement.current);
  }, []);

  return (
    <>
      <form
        id={props.id}
        ref={formElement}
        onSubmit={props.onSubmit}
        className={props.classes}
      >
        {props.children}
      </form>
    </>
  );
};
FormClassic.defaultProps = defaultProps;
